import React from 'react';
import { MapPin, Navigation, Info } from 'lucide-react';
export function ServiceArea() {
  const areas = ['Charlotte', 'Concord', 'Gastonia', 'Huntersville', 'Matthews', 'Rock Hill', 'Mint Hill', 'Pineville', 'Indian Trail', 'Cornelius', 'Mooresville', 'Kannapolis', 'Fort Mill', 'Belmont', 'Mount Holly'];
  return <div className="pt-44 pb-24" data-id="element-296">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297">
        <div className="text-center mb-16" data-id="element-298">
          <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6" data-id="element-299">
            Service Area
          </h1>
          <p className="text-slate-600 text-xl max-w-3xl mx-auto leading-relaxed" data-id="element-300">
            We proudly serve Charlotte and the surrounding North Carolina areas,
            helping our clients maintain their independence and actively
            participate in community life.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-301">
          <div className="bg-white p-8 rounded-3xl shadow-xl border border-slate-100" data-id="element-302">
            <div className="flex items-center mb-8" data-id="element-303">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mr-4" data-id="element-304">
                <Navigation className="w-6 h-6 text-blue-600" data-id="element-305" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900" data-id="element-306">
                Communities We Serve
              </h2>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-4 gap-x-6" data-id="element-307">
              {areas.map(city => <div key={city} className="flex items-center text-slate-700 font-medium group" data-id="element-308">
                  <MapPin className="w-4 h-4 text-blue-600 mr-2 group-hover:scale-125 transition-transform" data-id="element-309" />
                  {city}
                </div>)}
            </div>
            <div className="mt-12 p-6 bg-blue-50 rounded-2xl border border-blue-100 flex items-start" data-id="element-310">
              <Info className="w-6 h-6 text-blue-600 mr-4 flex-shrink-0 mt-1" data-id="element-311" />
              <p className="text-blue-900 text-sm leading-relaxed" data-id="element-312">
                Don't see your area listed? Give us a call at{' '}
                <strong data-id="element-313">(704) AMO-RIDE</strong>. We often accommodate requests
                for surrounding counties and long-distance transport.
              </p>
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden shadow-2xl h-[500px] border-8 border-white" data-id="element-314">
            <img src="https://images.unsplash.com/photo-1516738901171-8eb4fc13bd20?auto=format&fit=crop&q=80&w=1000" alt="Charlotte NC Area Map" className="w-full h-full object-cover" data-id="element-315" />
            <div className="absolute inset-0 bg-blue-900/10" data-id="element-316" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-317">
              <div className="bg-white p-4 rounded-full shadow-2xl animate-bounce" data-id="element-318">
                <MapPin className="w-10 h-10 text-blue-600" data-id="element-319" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}